import styled from 'styled-components'

export const CountUpCard = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 8px;
  width: 100%;
  padding: 16px 24px;
  border-radius: 32px;

  background: linear-gradient(
    180deg,
    rgba(8, 237, 220, 0.1) 0%,
    rgba(8, 237, 220, 0.15) 50%,
    rgba(8, 237, 220, 0.1) 100%
  );

  /* Brilho azul */
  box-shadow: 0px 0px 18px rgba(8, 237, 220, 0.1);
  border-radius: 32px;
  text-align: center;

  .card-title {
    color: ${(props) => props.theme.colors.primary};
  }
  .card-description {
    color: ${(props) => props.theme.colors.white};
    text-align: center;
    max-width: 80%;
  }

  @media (max-width: 990px) {
    border-radius: 8px;

    .card-title {
      font-size: ${(props) => props.theme.fontSizes.h3};
    }
    .card-description {
      font-size: ${(props) => props.theme.fontSizes.b3};
    }
  }
`
